module.exports = __webpack_public_path__ + "img/simcard.61e505a1.svg";